import Hero from './components/Hero';
import Indices from './components/Indices';
import Productos from './components/Productos';
import Footer from "./components/Footer";
import Clients from "./components/Clients";
import './styles/Global.css';
import './App.css';
import fondo from './assets/images/Fondopequeño.webp';

function App() {
  return (

    <div className="background-wrapper">
      <img
        src={fondo}
        alt="background"
        className="background-image"
      />
      <div className="content">
        <Hero />
        <Indices />
        <Clients />
        <Productos />
        <Footer />
     </div>
    </div>
  );
}

export default App;
